import PaymentsDialog from './PaymentsDialog';

export default PaymentsDialog;
